import styled from 'styled-components';

const AITaskConfigurationContainer = styled.div`
  background-color: white;
  border-radius: 15px;
  height: 100%;
`;

export default {
  AITaskConfigurationContainer
};
